import { CustomerKycStatus } from '../../@types';
import { KycVerificationTrigger } from '../../types/enums';
import KycVerificationCard from './KycVerificationCard';

type KycVerificationPanelProps = {
  allowLanguageSelection?: boolean;
  attemptsExceeded?: boolean;
  isPending?: boolean;
  onClose?: () => void;
  onStartVerification?: () => void;
  status?: CustomerKycStatus;
  trigger?: KycVerificationTrigger;
};

const KycVerificationPanel = ({
  allowLanguageSelection,
  attemptsExceeded,
  isPending = false,
  onClose,
  onStartVerification,
  status,
  trigger,
}: KycVerificationPanelProps) => (
  <KycVerificationCard
    allowLanguageSelection={allowLanguageSelection}
    attemptsExceeded={attemptsExceeded}
    isPending={isPending}
    onClose={onClose}
    onStartVerification={onStartVerification}
    status={status}
    trigger={trigger}
  />
);

export default KycVerificationPanel;
